import { useNavigate } from 'react-router-dom';

import { Button, Icon } from '@components/index';
import { GROUPS } from '@constants/routes';

interface CreateGroupHeaderProps {
  createdGroupId: string | null;
  step: 'basic' | 'member';
  onSave: () => void;
  isSaveDisabled: boolean;
  isLoading: boolean;
}

const CreateGroupHeader = ({
  createdGroupId,
  step,
  onSave,
  isSaveDisabled,
  isLoading
}: CreateGroupHeaderProps) => {
  const navigate = useNavigate();

  const handleSave = () => {
    onSave();
  };

  const handleBackNavigation = () => {
    if (step === 'basic') {
      navigate(GROUPS.HOME);
    } else {
      navigate(`${GROUPS.HOME}/${createdGroupId}`);
    }
  };

  return (
    <div className="flex h-22 w-full shrink-0 items-center justify-between bg-white p-6">
      <div className="flex items-center gap-2">
        <Icon
          className="cursor-pointer"
          name="arrow-left"
          onClick={handleBackNavigation}
        />
        <div className="text-2xl font-bold text-cofeeNeutral11">New group</div>
      </div>
      <div className="flex items-center gap-4">
        <Button
          label="Cancel"
          handleClick={handleBackNavigation}
          variant="tertiary"
          className="min-w-30"
        />
        <Button
          label={step === 'basic' ? 'Save and next' : 'Save'}
          handleClick={handleSave}
          variant="primary"
          className="min-w-30"
          disabled={isSaveDisabled}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default CreateGroupHeader;
